import React, {ReactElement} from 'react';
import {Icon, MenuItem, SxProps, Theme} from '@mui/material';
import {Link} from 'react-router-dom';
import {useRecordContext} from 'components/record/useRecordContext';
import {RecordType} from 'components/record/RecordContext';

const ActionMenuItemNav = (props: ActionMenuItemNavProps) => {
  const {label, sx = {}, icon = <Icon />, to} = props;
  const {record} = useRecordContext();

  const hrefTo = typeof to === 'function' ? to(record) : to;

  return (
    <MenuItem component={Link} to={hrefTo} sx={{...sx}}>
      {icon}
      {label}
    </MenuItem>
  );
};

export default ActionMenuItemNav;

export type ActionMenuItemNavProps = {
  to: string | ((record?: RecordType) => string);
  label: string;
  icon?: ReactElement;
  sx?: SxProps<Theme>;
};
